
import { defineComponent, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "app",
  setup() {
    const store = useStore();

    onBeforeMount(async () => {
      //@Todo Create outside token
    });

    // KeenThemes initializeComponents: solo Layout admin / ClientLayout post-LCP (PSI).
    store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);
  },
});
